import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AuthGuardMaxUsers, SharedModule, UserModule as UserModuleLib, UserService } from 'lib-trend-core';
import { ColorPickerDirective } from 'ngx-color-picker';
import { UserFormComponent } from './user-form/user-form.component';
import { UserRoutingModule } from './user-routing.module';
import { UserComponent } from './user.component';
import { UserUploadComponent } from './user-upload/user-upload.component';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    SharedModule,
    ColorPickerDirective,
    UserModuleLib,
    UserRoutingModule,
    MatSelectModule
  ],
  declarations: [
    UserComponent,
    UserFormComponent,
    UserUploadComponent,
  ],
  exports: [
    UserComponent,
    UserFormComponent
  ],
  providers: [UserService, AuthGuardMaxUsers],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserModule { }
